import MediaGallerySelectorRow from './MediaGallerySelectorRow';

export default MediaGallerySelectorRow;
